import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbDialogRef, NbDialogService, NbMediaBreakpointsService, NbMenuService, NbSearchService, NbSidebarService, NbThemeService, NbToastrService } from '@nebular/theme';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { Router } from '@angular/router';
import { HttpserviceService } from '../../../services/httpservice.service';
import { InfopaletComponent } from '../../../pages/camaras/palet/infopalet/infopalet.component';
import { PushNotificationService } from '../../../services/push-notification.service';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: any;
  isFullscreen = false;
  private currentUserId: number | null = null;
  private isChangingPassword: boolean = false;
  private menuSubscription: any;
  
  // Ubicaciones y Cámaras
  ubicaciones: any[] = [];
  ubicacionSeleccionada: any = null;
  camaras: any[] = [];
  camaraSeleccionada: any = null;
  ubicacionTemporal: any = null;
  camaraTemporal: any = null;
  camarasModal: any[] = [];
  cargandoUbicaciones = false;
  cargandoCamaras = false;
  cargandoCamarasModal = false;
  mostrarEntornoPruebas = false;
  private dialogRef?: NbDialogRef<any>;
  private paletSearchDialogRef?: NbDialogRef<any>;
  private lastPaletSearchTerm = '';
  private lastPaletSearchAt = 0;
  private readonly storageUbicacionKey = 'header_selected_ubicacion_id';
  private readonly storageCamaraKey = 'header_selected_camara_id';
  private readonly authTokenStorageKey = 'auth_app_token';

  @ViewChild('ubicacionDialog') ubicacionDialog!: TemplateRef<any>;
  
  // Notificaciones push
  notificacionesActivas = false;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  currentTheme = 'default';
  userEmail: string | null = null;
  userIdentifier: string | null = null;

  userMenu = [ { title: 'Cambiar Contraseña' }, { title: 'Logout', link: '/auth/logout'  } ];

  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private authService: NbAuthService,
    private router: Router,
    private searchService: NbSearchService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private http: HttpserviceService,
    private pushNotificationService: PushNotificationService,
  ) {
    this.materialTheme$ = this.themeService.onThemeChange()
      .pipe(map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }));
    this.authService.onTokenChange()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        const payload: any = token.getPayload();
        this.user = payload;
        this.userEmail = this.resolveUserEmail(payload);
        this.userIdentifier = this.resolveUserIdentifier(payload);
        if (payload && payload.user_id) {
          this.currentUserId = Number(payload.user_id);
          this.initNotificationStatus();
        } else {
          this.currentUserId = null;
        }
      } else {
        this.userEmail = null;
        this.userIdentifier = null;
        this.currentUserId = null;
      }
    });
    this.searchService.onSearchSubmit().subscribe(({ term }) => {
      this.searchPallet(term);
    });
  }


  private readonly onFullscreenChange = () => {
    this.actualizarEstadoPantallaCompleta();
  };

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.actualizarEstadoPantallaCompleta();
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    this.cargarEntorno();
    this.cargarUbicaciones();
    this.checkNotificationStatus();

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });
    this.menuSubscription = this.menuService.onItemClick()
    .subscribe((event) => {
      if (event.item.title === 'Cambiar Contraseña') {
        if (!this.isChangingPassword) {
          this.changeCurrentUserPassword();
        }
      } else if (event.item.title === 'Logout') {
        this.logout();
      }
    });
    this.userEmail = this.resolveUserEmail();
    this.userIdentifier = this.resolveUserIdentifier();
  }

  private resolveUserEmail(payload?: any): string | null {
    const sourcePayload = payload && typeof payload === 'object' ? payload : this.readStoredTokenPayload();
    const email = String(sourcePayload?.email || '').trim();
    return email !== '' ? email : null;
  }

  private resolveUserIdentifier(payload?: any): string | null {
    const sourcePayload = payload && typeof payload === 'object' ? payload : this.readStoredTokenPayload();
    const identifier = String(sourcePayload?.id_usuario || '').trim();
    if (identifier !== '') {
      return identifier;
    }

    const email = String(sourcePayload?.email || '').trim();
    return email !== '' ? email : null;
  }

  private readStoredTokenPayload(): any {
    const rawToken = localStorage.getItem('auth_app_token');
    if (!rawToken) {
      return null;
    }

    try {
      const tokenData = JSON.parse(rawToken);
      const token = tokenData?.value;
      if (!token || typeof token !== 'string') {
        return null;
      }

      const parts = token.split('.');
      if (parts.length < 2) {
        return null;
      }

      const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const padded = normalized.padEnd(normalized.length + ((4 - normalized.length % 4) % 4), '=');
      const decoded = decodeURIComponent(Array.prototype.map.call(atob(padded), (char: string) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2)).join(''));
      return JSON.parse(decoded);
    } catch (e) {
      return null;
    }
  }

  cargarEntorno(): void {
    this.http.getEnvironmentConfig().subscribe(
      (response: any) => {
        if (response?.code === 1) {
          this.mostrarEntornoPruebas = !response?.data?.en_produccion;
        }
      },
      () => {
        this.mostrarEntornoPruebas = false;
      },
    );
  }


  toggleFullscreen(): void {
    const doc = document as Document & {
      webkitExitFullscreen?: () => Promise<void> | void;
      mozCancelFullScreen?: () => Promise<void> | void;
      msExitFullscreen?: () => Promise<void> | void;
    };
    const element = document.documentElement as HTMLElement & {
      webkitRequestFullscreen?: () => Promise<void> | void;
      mozRequestFullScreen?: () => Promise<void> | void;
      msRequestFullscreen?: () => Promise<void> | void;
    };

    if (this.isFullscreen) {
      const exitFullscreen = doc.exitFullscreen
        || doc.webkitExitFullscreen
        || doc.mozCancelFullScreen
        || doc.msExitFullscreen;
      if (exitFullscreen) {
        Promise.resolve(exitFullscreen.call(doc)).catch(() => undefined);
      }
      return;
    }

    const requestFullscreen = element.requestFullscreen
      || element.webkitRequestFullscreen
      || element.mozRequestFullScreen
      || element.msRequestFullscreen;
    if (requestFullscreen) {
      Promise.resolve(requestFullscreen.call(element)).catch(() => undefined);
    }
  }

  private actualizarEstadoPantallaCompleta(): void {
    const doc = document as Document & {
      webkitFullscreenElement?: Element | null;
      mozFullScreenElement?: Element | null;
      msFullscreenElement?: Element | null;
    };
    this.isFullscreen = !!(
      doc.fullscreenElement
      || doc.webkitFullscreenElement
      || doc.mozFullScreenElement
      || doc.msFullscreenElement
    );
  }

  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    this.destroy$.next();
    this.destroy$.complete();
    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  logout() {
    this.authService.logout('email').subscribe(() => {
      this.router.navigate(['/auth/login']);
    });
  }

  async forceRefreshApp(): Promise<void> {
    const preservedEntries: Array<[string, string]> = [];
    [
      this.authTokenStorageKey,
      this.storageUbicacionKey,
      this.storageCamaraKey,
    ].forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        preservedEntries.push([key, value]);
      }
    });

    try {
      sessionStorage.clear();
    } catch (e) {}

    try {
      localStorage.clear();
      preservedEntries.forEach(([key, value]) => localStorage.setItem(key, value));
    } catch (e) {}

    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }
    } catch (e) {}

    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }
    } catch (e) {}

    const url = new URL(window.location.href);
    url.searchParams.set('v', String(Date.now()));
    window.location.href = url.toString();
  }

  searchPallet(term: string) {
    const normalizedTerm = String(term || '').trim();
    if (!normalizedTerm) {
      return;
    }

    const now = Date.now();
    if (this.lastPaletSearchTerm === normalizedTerm && (now - this.lastPaletSearchAt) < 800) {
      return;
    }

    this.lastPaletSearchTerm = normalizedTerm;
    this.lastPaletSearchAt = now;

    if (this.paletSearchDialogRef) {
      this.paletSearchDialogRef.close();
      this.paletSearchDialogRef = undefined;
    }

    this.paletSearchDialogRef = this.dialogService.open(InfopaletComponent, {
      context: {
        data: normalizedTerm
      },
    });

    this.paletSearchDialogRef.onClose.subscribe(() => {
      this.paletSearchDialogRef = undefined;
      window.setTimeout(() => {
        this.lastPaletSearchTerm = '';
        this.lastPaletSearchAt = 0;
      }, 250);
    });
  }

  cargarUbicaciones(): void {
    this.cargandoUbicaciones = true;
    const empresaId = (this.http as any).idempresa ?? 1;
    this.http.getUbicaciones(empresaId).subscribe(
      (response: any) => {
        if (response.code === 1 && response.data.length > 0) {
          this.ubicaciones = response.data;
          const savedUbicacionId = this.readStoredNumber(this.storageUbicacionKey);
          const initialUbicacion = this.findUbicacionById(savedUbicacionId) || this.ubicaciones[0] || null;

          if (initialUbicacion) {
            this.applyUbicacionSeleccion(initialUbicacion, false);
          }
        }
        this.cargandoUbicaciones = false;
      },
      (error) => {
        console.error('Error al cargar ubicaciones', error);
        this.cargandoUbicaciones = false;
      }
    );
  }

  cargarCamaras(ubicacionId: number, options: { keepCurrent?: boolean; preferredCamaraId?: number | null; updateModal?: boolean } = {}): void {
    const { keepCurrent = false, preferredCamaraId = null, updateModal = false } = options;

    if (updateModal) {
      this.cargandoCamarasModal = true;
      this.camarasModal = [];
      this.camaraTemporal = null;
    } else {
      this.cargandoCamaras = true;
      this.camaras = [];
      this.camaraSeleccionada = null;
    }

    this.http.getCamaras(ubicacionId).subscribe(
      (response: any) => {
        const camarasNormalizadas = response.code === 1 && response.data.length > 0
          ? (response.data || []).map((c: any) => ({
              ...c,
              id: c.idcamara != null ? Number(c.idcamara) : Number(c.id),
            }))
          : [];

        if (updateModal) {
          this.camarasModal = camarasNormalizadas;
          const selectedCamara = this.findCamaraById(camarasNormalizadas, preferredCamaraId) || camarasNormalizadas[0] || null;
          this.camaraTemporal = selectedCamara;
          this.cargandoCamarasModal = false;
          return;
        }

        this.camaras = camarasNormalizadas;
        const selectedCamara = this.findCamaraById(camarasNormalizadas, preferredCamaraId) || camarasNormalizadas[0] || null;

        if (selectedCamara) {
          this.applyCamaraSeleccion(selectedCamara, keepCurrent);
        } else {
          this.camaraSeleccionada = null;
          (this.http as any).idcamara = null;
          this.persistSelection();
        }

        this.cargandoCamaras = false;
      },
      (error) => {
        console.error('Error al cargar cámaras', error);
        if (updateModal) {
          this.cargandoCamarasModal = false;
        } else {
          this.cargandoCamaras = false;
        }
      }
    );
  }

  openUbicacionModal(): void {
    this.ubicacionTemporal = this.ubicacionSeleccionada;
    this.camaraTemporal = this.camaraSeleccionada;
    this.camarasModal = [...this.camaras];

    const preferredCamaraId = this.getCamaraId(this.camaraSeleccionada);
    if (this.ubicacionTemporal?.id) {
      this.cargarCamaras(this.ubicacionTemporal.id, {
        preferredCamaraId,
        updateModal: true,
      });
    }

    this.dialogRef = this.dialogService.open(this.ubicacionDialog, {
      closeOnBackdropClick: true,
      closeOnEsc: true,
      hasScroll: true,
      autoFocus: false,
    });
  }

  onUbicacionTemporalChange(ubicacion: any): void {
    if (!ubicacion) {
      return;
    }

    this.ubicacionTemporal = ubicacion;
    this.camaraTemporal = null;
    this.cargarCamaras(ubicacion.id, { updateModal: true });
  }

  onCamaraTemporalChange(camara: any): void {
    this.camaraTemporal = camara || null;
  }

  applyUbicacionModalSelection(): void {
    if (!this.ubicacionTemporal) {
      return;
    }

    this.ubicacionSeleccionada = this.ubicacionTemporal;
    (this.http as any).idubicacion = this.ubicacionTemporal?.id ?? null;

    this.camaraSeleccionada = this.camaraTemporal || null;
    (this.http as any).idcamara = this.getCamaraId(this.camaraTemporal);

    this.camaras = [...this.camarasModal];
    this.persistSelection();
    this.dialogRef?.close();
  }

  closeUbicacionModal(): void {
    this.dialogRef?.close();
  }

  compareItems(u1: any, u2: any): boolean {
    return (u1?.id ?? u1?.idcamara ?? null) === (u2?.id ?? u2?.idcamara ?? null);
  }

  getUbicacionSeleccionadaLabel(): string {
    if (!this.ubicacionSeleccionada) {
      return 'Seleccionar ubicación';
    }

    return this.ubicacionSeleccionada.nombre || this.ubicacionSeleccionada.name || ('Ubicación ' + this.ubicacionSeleccionada.id);
  }

  getCamaraSeleccionadaLabel(): string {
    if (!this.camaraSeleccionada) {
      return 'Sin cámara';
    }

    return this.camaraSeleccionada.nombre_camara || this.camaraSeleccionada.nombre || this.camaraSeleccionada.name || ('Cámara ' + this.getCamaraId(this.camaraSeleccionada));
  }

  private applyUbicacionSeleccion(ubicacion: any, persist: boolean): void {
    this.ubicacionSeleccionada = ubicacion;
    (this.http as any).idubicacion = ubicacion?.id ?? null;

    if (persist) {
      this.persistSelection();
    }

    const preferredCamaraId = this.readStoredNumber(this.storageCamaraKey);
    this.cargarCamaras(ubicacion.id, {
      keepCurrent: true,
      preferredCamaraId,
    });
  }

  private applyCamaraSeleccion(camara: any, persist: boolean): void {
    this.camaraSeleccionada = camara || null;
    (this.http as any).idcamara = this.getCamaraId(camara);

    if (persist) {
      this.persistSelection();
    }
  }

  private findUbicacionById(id: number | null): any | null {
    if (id == null) {
      return null;
    }

    return this.ubicaciones.find((u: any) => Number(u.id) === Number(id)) || null;
  }

  private findCamaraById(camaras: any[], id: number | null): any | null {
    if (id == null) {
      return null;
    }

    return camaras.find((c: any) => Number(this.getCamaraId(c)) === Number(id)) || null;
  }

  private getCamaraId(camara: any): number | null {
    if (!camara) {
      return null;
    }

    const value = camara?.idcamara ?? camara?.id;
    return value != null ? Number(value) : null;
  }

  private persistSelection(): void {
    const ubicacionId = this.ubicacionSeleccionada?.id ?? null;
    const camaraId = this.getCamaraId(this.camaraSeleccionada);

    if (ubicacionId != null) {
      localStorage.setItem(this.storageUbicacionKey, String(ubicacionId));
    }

    if (camaraId != null) {
      localStorage.setItem(this.storageCamaraKey, String(camaraId));
    } else {
      localStorage.removeItem(this.storageCamaraKey);
    }
  }

  private readStoredNumber(key: string): number | null {
    const value = localStorage.getItem(key);
    if (value == null || value === '') {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  checkNotificationStatus(): void {
    this.pushNotificationService.deviceRegistered.subscribe(
      (registrado: boolean) => {
        this.notificacionesActivas = registrado;
        console.log('Estado notificaciones (stream):', registrado);
      }
    );
  }

  /**
   * Consulta al servidor si el usuario actual tiene notificaciones registradas
   */
  private initNotificationStatus(): void {
    const userId = this.getCurrentUserId();
    if (!userId) {
      return;
    }

    this.pushNotificationService.checkDeviceRegistration(userId).subscribe(
      (response: any) => {
        if (response.code === 1 && response.data && typeof response.data.registrado === 'boolean') {
          this.notificacionesActivas = response.data.registrado;
          // Sincronizamos también el BehaviorSubject del servicio
          this.pushNotificationService.setDeviceRegisteredFromServer(response.data.registrado);
          console.log('Estado notificaciones (server):', response.data.registrado);
        }
      },
      (error) => {
        console.error('Error al comprobar estado de notificaciones:', error);
      }
    );
  }

  /**
   * Obtiene el id de usuario actual desde el token JWT (campo user_id)
   */
  private getCurrentUserId(): number | null {
    return this.currentUserId;
  }

  /**
   * Cambia la contraseña del usuario actual usando prompts nativos
   */
  changeCurrentUserPassword(): void {
    this.isChangingPassword = true;

    const newPassword = prompt('Introduce la nueva contraseña:');
    if (!newPassword || newPassword.trim() === '') {
      this.toastrService.warning('La contraseña no puede estar vacía', 'Aviso');
      this.isChangingPassword = false;
      return;
    }
    const passwordConfirm = prompt('Confirma la nueva contraseña:');
    if (!passwordConfirm || passwordConfirm !== newPassword) {
      this.toastrService.danger('Las contraseñas no coinciden', 'Error');
      this.isChangingPassword = false;
      return;
    }
    if (!confirm('¿Estás seguro de cambiar tu contraseña?')) {
      this.isChangingPassword = false;
      return;
    }
    this.http.changeCurrentUserPassword(newPassword, passwordConfirm).subscribe(
      (response: any) => {
        if (response.code === 1) {
          this.toastrService.success(response.mensaje || 'Contraseña actualizada correctamente', 'Éxito');
        } else {
          this.toastrService.danger(response.mensaje || 'Error al cambiar contraseña', 'Error');
        }
        this.isChangingPassword = false;
      },
      (error) => {
        console.error('Error al cambiar contraseña:', error);
        this.toastrService.danger('Error de conexión al cambiar contraseña', 'Error');
        this.isChangingPassword = false;
      }
    );
  }

  toggleNotifications(): void {
    const userId = this.getCurrentUserId();
    
    if (!userId) {
      this.toastrService.danger('No seha podido obtener el usuario actual para registrar notificaciones', 'Error');
      console.error('Push notifications: userId no disponible en el token', this.user);
      return;
    }
    
    if (!this.notificacionesActivas) {
      this.pushNotificationService.registerDevice(userId, 'web').subscribe(
        (response: any) => {
          if (response.code === 1) {
            this.notificacionesActivas = true;
            this.toastrService.success('Notificaciones habilitadas', 'Éxito');
          } else {
            this.toastrService.danger('Error al habilitar notificaciones', 'Error');
            console.error('Error respuesta registrar_dispositivo:', response);
          }
        },
        (error) => {
          this.toastrService.danger('Error al habilitar notificaciones', 'Error');
          console.error('Error registrar_dispositivo:', error);
        }
      );
    } else {
      this.pushNotificationService.unregisterDevice(userId).subscribe(
        (response: any) => {
          if (response.code === 1) {
            this.notificacionesActivas = false;
            this.toastrService.info('Notificaciones deshabilitadas', 'Info');
          } else {
            this.toastrService.danger('Error al deshabilitar notificaciones', 'Error');
            console.error('Error respuesta desactivar_dispositivo:', response);
          }
        },
        (error) => {
          this.toastrService.danger('Error al deshabilitar notificaciones', 'Error');
          console.error('Error desactivar_dispositivo:', error);
        }
      );
    }
  }
}
